var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quillEditor" },
    [
      _c("quill-editor", {
        ref: _vm.quillId,
        staticClass: "quill",
        attrs: { content: _vm.content, options: _vm.editorOption },
        on: {
          change: function($event) {
            return _vm.onEditorChange($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "van-uploader",
        {
          staticClass: "upload",
          attrs: {
            "after-read": _vm.afterRead,
            multiple: "",
            id: _vm.quillId + "Upload"
          }
        },
        [
          _c("van-icon", { attrs: { name: "plus" } }),
          _vm._v(" "),
          _c("p", [_vm._v("上传图片")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c8f382f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c8f382f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/component/quillEditImg.vue
// module id = null
// module chunks = 